module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/dealing-with-rodents/"},"excerpt":"Do you have a rodent infestation? Are they eating your cheese or your crops and leaving their droppings all over the place? Then I’m your…","timeToRead":1,"frontmatter":{"title":"Dealing With Rodents","tags":["birds","pest control","rodents"]}}}]}},"pathContext":{"tag":"pest control"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-pest-control.json
// module id = 770
// module chunks = 234153087885123